import { Download, FileText, File as FileIcon } from "lucide-react";
import { fileUrl } from "@/lib/api";

function isImage(ct, name = "") {
  return (ct || "").startsWith("image/") || /\.(jpe?g|png|gif|webp|heic|heif)$/i.test(name);
}
function isPdf(ct, name = "") {
  return (ct || "").includes("pdf") || /\.pdf$/i.test(name);
}

export function FilePreview({ file, testId }) {
  const href = fileUrl(file.url);
  const img = isImage(file.content_type, file.filename);
  const pdf = isPdf(file.content_type, file.filename);
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-card" data-testid={testId}>
      {img ? (
        <a href={href} target="_blank" rel="noreferrer">
          <img src={href} alt={file.filename} className="h-44 w-full bg-secondary object-contain" />
        </a>
      ) : pdf ? (
        <embed src={href} type="application/pdf" className="h-56 w-full bg-secondary" />
      ) : (
        <div className="flex h-28 items-center justify-center bg-secondary">
          <FileIcon className="h-10 w-10 text-muted-foreground" />
        </div>
      )}
      <div className="flex items-center justify-between gap-2 px-3 py-2">
        <span className="flex min-w-0 items-center gap-1.5 text-xs text-muted-foreground">
          <FileText className="h-3.5 w-3.5 shrink-0" />
          <span className="truncate">{file.filename || "File"}</span>
        </span>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          download
          className="inline-flex shrink-0 items-center gap-1 rounded-lg border border-border px-2.5 py-1 text-xs font-medium hover:bg-secondary"
        >
          <Download className="h-3 w-3" /> Download
        </a>
      </div>
    </div>
  );
}

export default FilePreview;
